(ns ui.notify
  "Replicant integration for the `/db-view/notify` long-poll endpoint."
  (:require [app.util.transit :as transit]
            [cljs-http.client :as http]
            [cljs.core.async :refer [<!] :as a]
            [parts.replicant.query :as query])
  (:require-macros [cljs.core.async.macros :refer [go-loop]]))

(defonce listening?
  (atom false))

(defn- wait-until-visible
  "Returns a channel that yields `true` when the browser tab becomes
   visible, so an unseen tab does not wake up the server."
  []
  (go-loop []
    (if (= js/document.visibilityState
           "visible")
      true
      (do
        (<! (a/timeout 100))
        (recur)))))

(defn- refresh-queries
  [state]
  (filter :query/refresh?
          (keys (:ui.query/log state))))

(defn- refresh-query!
  [store q]
  (-> (js/fetch "/query"
                #js {:method "POST"
                     :body (transit/transit-encode q)})
      (.then (fn [response]
               (.text response)))
      (.then (fn [text]
               (let [result (transit/transit-decode text)]
                 (swap! store
                        query/receive-response
                        (js/Date.) q result))))
      (.catch (fn [_err]))))

(defn- refresh-queries!
  [store]
  (doseq [q (refresh-queries @store)]
    (refresh-query! store q)))

(defn start-listening!
  "Starts the Replicant db-view notify loop. When Datomic changes wake the
   long-poll request, all queries in the Replicant store marked with
   `:query/refresh? true` are refreshed."
  [store]
  (when (compare-and-set! listening? false true)
    (go-loop []
      (<! (wait-until-visible))
      (let [response-chan (http/request
                            {:request-method :post
                             :url "/db-view/notify"})]
        ;; Refresh immediately to catch transactions that happened between the
        ;; previous long-poll ending and this one starting.
        (refresh-queries! store)
        (let [response (<! response-chan)]
          (if (= (:status response)
                 200)
            (refresh-queries! store)
            (<! (a/timeout (+ 200
                              (rand-int 800))))))
        (recur)))))
